import { render, staticRenderFns } from "./PigInfoTable.vue?vue&type=template&id=8340bd1c&scoped=true"
import script from "./PigInfoTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PigInfoTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PigInfoTable.vue?vue&type=style&index=0&id=8340bd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8340bd1c",
  null
  
)

export default component.exports